const initialState = {
  loading: false,
  questionIds: [],
  totalPages: 0,
  totalCount: 0,
  currentPage: 1,
};

const getQuestionsFetchedIds = (action) =>
  action.result ? action.result : initialState.questionIds;

export default function questionsListReducer(state = initialState, action) {
  switch (action.type) {
    case "QUESTIONS_SEARCH_RESET":
      return initialState;
    case "QUESTIONS_SEARCH_FETCH_REQUESTED":
      return { ...state, loading: true };
    case "QUESTIONS_SEARCH_FETCHED":
      return {
        ...state,
        loading: false,
        questionIds: getQuestionsFetchedIds(action),
        // O `|| 0` protege respostas antigas em cache e o caso de a API não
        // mandar os totais; hoje o envelope sempre vem com eles, mesmo zerado.
        totalPages: action.totalPages || 0,
        totalCount: action.totalCount || 0,
        currentPage: action.currentPage || 1,
      };
    default:
      return state;
  }
}
